module.exports = __webpack_public_path__ + "static/img/1.1d3c548.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/sp/1.png
// module id = t+WK
// module chunks = 0